export default __webpack_public_path__ + "static/FritzphoneC4_01-c42855dc289efca8c2b4908b95d805de.webp";